import axios from 'axios'
const moduleGroupParent = {
  namespaced: true,
  state: () => {
    return {
      listGroupParent: [],
      pagination: {},
      detailGroupParent: {},
      isError: false,
      errMessage: ''
    }
  },
  mutations: {
    mutationGroupParent (state, payload) {
      state.listGroupParent = payload
    },
    setPagination (state, payload) {
      state.pagination = payload
    },
    setDetail (state, payload) {
      state.detailGroupParent = payload
    },
    setIsError (state, payload) {
      state.isError = payload
    },
    setErrorMsg (state, payload) {
      state.errMessage = payload
    }
  },
  actions: {
    actionGroupParent (context, data) {
      axios.get(`${context.rootState.setURL}/v1/question-parent`,
        { headers: { token: context.rootState.auth.token } }).then((response) => {
        context.commit('mutationGroupParent', response.data.data)
        context.commit('setPagination', response.data.pagination)
        context.commit('setIsError', false)
      }).catch(() => {
        context.commit('setIsError', true)
        context.commit('setErrorMsg', 'Data tidak ditemukan.')
      })
    },
    actionDetail (context, id) {
      axios.get(`${context.rootState.setURL}/v1/question-parent/${id}`,
        { headers: { token: context.rootState.auth.token } }).then((response) => {
        context.commit('setDetail', response.data.data[0])
      }).catch(() => {})
    },
    actionInsert (context, data) {
      return new Promise((resolve, reject) => {
        axios.post(`${context.rootState.setURL}/v1/question-parent`, data, { headers: { token: context.rootState.auth.token } }).then((response) => {
          resolve(response.data)
        }).catch((err) => {
          reject(err.response.data.message)
        })
      })
    },
    actionDelete (context, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`${context.rootState.setURL}/v1/question-parent/${id}`,
          { headers: { token: context.rootState.auth.token } }).then((response) => {
          resolve(response)
        }).catch(() => {})
      })
    }
  },
  getters: {
    getGroupParent (state) {
      return state.listGroupParent
    },
    getPagination (state) {
      return state.pagination
    },
    getDetail (state) {
      return state.detailGroupParent
    },
    isError (state) {
      return state.isError
    },
    errMessage (state) {
      return state.errMessage
    }
  }
}

export default moduleGroupParent
